"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _Popup = _interopRequireDefault(require("./Popup"));

require("../styles/_credits-info.scss");

function getCreditsTotal(_ref) {
  var teams = _ref.teams,
      creditBalance = _ref.creditBalance,
      creditType = _ref.creditType;
  return "SHARE" === creditType ? creditBalance : teams.reduce(function (total, team) {
    var teamCreditBalance = team.creditBalance;
    return teamCreditBalance ? {
      balance: teamCreditBalance.balance + total.balance,
      rolloverBalance: teamCreditBalance.rolloverBalance + total.rolloverBalance
    } : total;
  }, {
    balance: 0,
    rolloverBalance: 0
  });
}

function togglePopover(_ref2) {
  var setIsOpen = _ref2.setIsOpen,
      isOpen = _ref2.isOpen;
  return function () {
    setIsOpen(isOpen);
  };
}

function CreditsInfo(_ref3) {
  var isUnlimited = _ref3.isUnlimited,
      creditBalance = _ref3.creditBalance,
      creditType = _ref3.creditType,
      _ref3$teams = _ref3.teams,
      teams = void 0 === _ref3$teams ? [] : _ref3$teams;
  if (!creditType) return null;

  var _useState = (0, _react.useState)(!1),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1],
      creditsTotalCallback = (0, _react.useCallback)(function () {
    return getCreditsTotal({
      teams: teams,
      creditBalance: creditBalance,
      creditType: creditType
    });
  }, [teams, creditBalance, creditType]),
      totalCreditsBalance = creditsTotalCallback(),
      balanceToDisplay = totalCreditsBalance.balance + totalCreditsBalance.rolloverBalance;

  return _react["default"].createElement("div", {
    className: "credits-wrapper"
  }, _react["default"].createElement(_uiKit.Button, {
    small: !0,
    className: "credits-wrapper__credits-info",
    onClick: togglePopover({
      setIsOpen: setIsOpen,
      isOpen: !isOpen
    }),
    type: "button",
    tabIndex: 0,
    onKeyDown: togglePopover({
      setIsOpen: setIsOpen,
      isOpen: !isOpen
    })
  }, _react["default"].createElement("div", {
    className: "credits-wrapper__credits-info__credits"
  }, _react["default"].createElement(_uiKit.Icon, {
    name: "credits",
    size: 15,
    color: "black"
  }), "SHARE" === creditType && isUnlimited ? _react["default"].createElement(_uiKit.Icon, {
    name: "unlimited",
    size: 15,
    color: "black"
  }) : _react["default"].createElement("span", null, balanceToDisplay))), isOpen ? _react["default"].createElement(_Popup["default"], {
    creditBalance: creditBalance,
    isUnlimited: isUnlimited,
    creditType: creditType,
    teams: teams,
    onOutsideClick: togglePopover({
      setIsOpen: setIsOpen,
      isOpen: !1
    })
  }) : null);
}

var _default = (0, _react.memo)(CreditsInfo);

exports["default"] = _default;